
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { mergeStyleSets } from '@uifabric/merge-styles';

import { useToken } from '../../project';

import { LOGOUT_ACTION_TYPE } from '../../common/client/sagas/auth';

const AccessDeniedPermission = (props) => {

    const classNames = mergeStyleSets({
        root: {
            display: 'flex',
            flexDirection: 'column',
            flex: '1 0',
            alignItems: 'center'
        },
        info: {
            paddingTop: 8
        },
        login: {
            paddingTop: 32
        }
    });

    const token = useToken();
    const user = useSelector(state => {
        return state.auth.data ? state.auth.data.user : null;
    });
    const appProjectId = useSelector(state => {
        return state.app.projectId;
    });

    const dispatch = useDispatch();

    const logout = (token) => dispatch({
        type: LOGOUT_ACTION_TYPE.DEFAULT, token
    });

    const handleClick = () => {
        logout(token);
    }

    return (
        <div className={classNames.root}>
            <div className={classNames.info}>Nemáte dostatečná oprávnění pro přístup k této aplikaci.</div>
            {(!!user && !props.onlyInfo)
                ? <React.Fragment>
                    <div className={classNames.info}>Aktuálně přihlášený uživatel <b>{user.fullName} ({user.username})</b> z domény <b>{user.projectId}</b></div>
                    <div className={classNames.info}>Je potřeba se přihlásit účtem z domény <b>{appProjectId}</b></div>

                </React.Fragment>
                : null
            }
            {(!props.onlyInfo)
                ? <div className={classNames.login}>
                    <Link onClick={handleClick}>Znovu přihlásit</Link>
                </div>
                : null
            }
        </div>
    );
}

export default AccessDeniedPermission;
